export enum EToolChoice {
  AUTO = 'auto',
  REQUIRED = 'required',
  NONE = 'none',
  ANY = 'any',
}

export const TOOL_CHOICE_LABELS: Record<EToolChoice, string> = {
  [EToolChoice.AUTO]: 'Tools auto-selected by LLM',
  [EToolChoice.REQUIRED]: 'Use at least one tool',
  [EToolChoice.ANY]: 'Use at least one tool',
  [EToolChoice.NONE]: "Don't use any tools",
};

export const DEFAULT_TOOL_CHOICE = EToolChoice.AUTO;

export const PROVIDER_TOOL_CHOICES: Record<string, Array<EToolChoice>> = {
  ChatAnthropic: [EToolChoice.AUTO, EToolChoice.ANY],
  ChatOpenAI: [EToolChoice.AUTO, EToolChoice.REQUIRED, EToolChoice.NONE],
  CustomModelEndpoint: [
    EToolChoice.AUTO,
    EToolChoice.REQUIRED,
    EToolChoice.NONE,
  ],
  ChatVertexAI: [EToolChoice.AUTO, EToolChoice.ANY, EToolChoice.NONE],
  ChatMistralAI: [EToolChoice.AUTO, EToolChoice.ANY, EToolChoice.NONE],
  ChatGroq: [EToolChoice.AUTO, EToolChoice.REQUIRED, EToolChoice.NONE],
  AzureChatOpenAI: [EToolChoice.AUTO, EToolChoice.NONE],
  BedrockChat: [EToolChoice.AUTO, EToolChoice.ANY], // Tool section is only rendered for Bedrock when model is Anthropic
  ChatBedrockConverse: [EToolChoice.AUTO, EToolChoice.ANY],
} satisfies Record<string, Array<EToolChoice>>;

// When we switch providers, we need to map the tool choice to the new provider's tool choice
// This constructs a mapping from the old tool choice to a new tool choice supported by the new provider
export const TOOL_CHOICE_MAPPING = Object.fromEntries(
  Object.entries(PROVIDER_TOOL_CHOICES).map(([model, supportedChoices]) => [
    model,
    Object.values(EToolChoice).reduce((mapping, choice) => {
      if (supportedChoices.includes(choice)) {
        mapping[choice] = choice;
      } else if (
        choice === EToolChoice.REQUIRED &&
        supportedChoices.includes(EToolChoice.ANY)
      ) {
        mapping[choice] = EToolChoice.ANY;
      } else if (
        choice === EToolChoice.ANY &&
        supportedChoices.includes(EToolChoice.REQUIRED)
      ) {
        mapping[choice] = EToolChoice.REQUIRED;
      } else {
        mapping[choice] = DEFAULT_TOOL_CHOICE;
      }
      return mapping;
    }, {} as Record<EToolChoice, EToolChoice>),
  ])
) as Record<string, Record<EToolChoice, EToolChoice>>;

export const SUPPORTS_PARALLEL_TOOL_CALLS = [
  'ChatOpenAI',
  'AzureChatOpenAI',
  'CustomModelEndpoint',
];
